export default __webpack_public_path__ + "static/media/gslogo.6563eccc.png";